import { SvgProps } from "@/utils/types";
import React from "react";

export const AppleHealth = ({
  primaryColor = "#D4DF65",
  outlineColor = "#540389",
  secondaryColor = "#F96E09",
  tertiaryColor = "#C9BFFB",
  className,
}: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="79"
    viewBox="0 0 74 79"
    className={className}
    fill="none"
  >
    <path
      d="M37.1806 72.1777C37.1806 72.1777 39.5322 77 47.4146 77C56.6763 77 67.7314 63.0739 71.1471 49.7669C74.2672 37.6003 69.0254 24 52.1374 24C42.8165 24 39.3614 29.1677 36.6486 29.1677C33.9291 29.1677 31.1834 24 21.8691 24C4.97456 24 -0.267215 37.6003 2.85289 49.7669C6.26202 63.0739 17.317 77 26.5854 77C34.4678 77 37.1872 72.1842 37.1872 72.1842L37.1806 72.1777Z"
      fill={primaryColor}
      stroke={outlineColor}
      strokeWidth="3.5"
      strokeLinejoin="round"
    />
    <path
      d="M25 13C25 13 37.3459 15.1402 36.9926 30"
      stroke={outlineColor}
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.1469 2C48.1469 2 39.272 2.98919 35.5928 8.90426C31.9136 14.8193 35.7606 21.9174 35.7606 21.9174C35.7606 21.9174 43.3303 23.0269 47.0095 17.1119C50.6887 11.1968 48.1406 2 48.1406 2"
      fill={tertiaryColor}
    />
    <path
      d="M48.1469 2C48.1469 2 39.272 2.98919 35.5928 8.90426C31.9136 14.8193 35.7606 21.9174 35.7606 21.9174C35.7606 21.9174 43.3303 23.0269 47.0095 17.1119C50.6887 11.1968 48.1406 2 48.1406 2"
      stroke={outlineColor}
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49 45.9789H42.3226V39H33.6774V45.9789H27V55.0144H33.6774V62H42.3226V55.0144H49V45.9789Z"
      fill={secondaryColor}
      stroke={outlineColor}
      strokeWidth="3.5"
      strokeLinejoin="round"
    />
    <path
      d="M43 10C37.6661 16.5755 37 22 37 22"
      stroke={outlineColor}
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 31C19 31 7.46088 31.6531 8.01966 47H12.8467C12.8467 47 10.4904 37.6416 19 31Z"
      fill={outlineColor}
    />
  </svg>
);
